import { z } from "zod";
import {
  HerSkinMessageIdSchema,
  HerSkinRunIdSchema,
  HerSkinSessionIdSchema,
  IsoDateTimeSchema,
} from "./common.js";
import { MessageAttachmentSchema } from "./agent-capabilities.js";

export const MessageRoleSchema = z.enum(["user", "assistant", "system"]);
export const MessageFormatSchema = z.enum(["text", "markdown"]);
export const MessageStatusSchema = z.enum([
  "sending",
  "streaming",
  "completed",
  "failed",
  "partial",
]);

export const MessageSchema = z
  .object({
    id: HerSkinMessageIdSchema,
    sessionId: HerSkinSessionIdSchema,
    runId: HerSkinRunIdSchema.nullable(),
    role: MessageRoleSchema,
    format: MessageFormatSchema,
    status: MessageStatusSchema,
    content: z.string().max(2_000_000),
    contentHash: z.string().min(8).max(128).optional(),
    attachments: z.array(MessageAttachmentSchema).max(5).default([]),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
    /** unknown 时日期只是内部排序占位，产品不得显示为真实消息时间或用于耗时计算。 */
    timeAccuracy: z.enum(["exact", "unknown"]).optional(),
  })
  .strict();

export const MessageStartedPayloadSchema = z
  .object({
    messageId: HerSkinMessageIdSchema,
    role: z.literal("assistant"),
  })
  .strict();

export const MessageDeltaPayloadSchema = z
  .object({
    messageId: HerSkinMessageIdSchema,
    delta: z.string().min(1).max(262_144),
  })
  .strict();

export const MessageCompletedPayloadSchema = z
  .object({
    messageId: HerSkinMessageIdSchema,
    content: z.string().max(2_000_000),
    contentHash: z.string().min(8).max(128),
    format: z.literal("markdown"),
  })
  .strict();

export type Message = z.infer<typeof MessageSchema>;
export type MessageDeltaPayload = z.infer<typeof MessageDeltaPayloadSchema>;
export type MessageCompletedPayload = z.infer<typeof MessageCompletedPayloadSchema>;
